export default __webpack_public_path__ + "static/media/wheelbox-bg.9afc408b.png";